import { getLocaleNamespace } from '@wix/wixstores-client-core/dist/es/src/getLocaleNamespace';
import { compact } from '../lib/compact';
import * as _ from 'lodash';
var MultilingualService = /** @class */ (function () {
    function MultilingualService(publicData, widgetSettings, multiLangFields, defaultLocale) {
        if (publicData === void 0) { publicData = {}; }
        this.publicData = publicData;
        this.widgetSettings = widgetSettings;
        this.multiLangFields = multiLangFields;
        this.defaultLocale = defaultLocale;
        /* istanbul ignore next: todo: test */
        if (multiLangFields) {
            this.isPrimaryLanguage = this.multiLangFields.isPrimaryLanguage;
            this.lang = this.multiLangFields.lang;
            this.locale = this.multiLangFields.locale;
        }
        else {
            this.isPrimaryLanguage = true;
            this.lang = this.defaultLocale;
        }
    }
    MultilingualService.prototype.get = function (key) {
        if (this.isPrimaryLanguage) {
            return this.publicData[key];
        }
        else {
            var widgetSettingsTextsMap = this.widgetSettings[getLocaleNamespace(this.lang)];
            return widgetSettingsTextsMap === null || widgetSettingsTextsMap === void 0 ? void 0 : widgetSettingsTextsMap[key];
        }
    };
    MultilingualService.prototype.getAll = function () {
        return this.isPrimaryLanguage ? this.publicData : this.widgetSettings[getLocaleNamespace(this.lang)];
    };
    MultilingualService.prototype.setWidgetSettings = function (data) {
        this.widgetSettings = data;
    };
    MultilingualService.prototype.setPublicData = function (data) {
        this.publicData = data;
    };
    MultilingualService.prototype.getMergedTranslationsAsPublicData = function (freeTextFields) {
        var purgedPublicData = _.omit(this.publicData, freeTextFields);
        return compact(_.merge({}, purgedPublicData, this.getAll()));
    };
    return MultilingualService;
}());
export { MultilingualService };
//# sourceMappingURL=MultilingualService.js.map